import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreateSchool } from '../../../actions/Activites/School';
import { baseUrl } from '../../../nametitle/dataUrl';

const ModalAddSchoolBible = () => {
  const  navigate =  useNavigate();

  const [coverPicture, setcoverPicture] = useState("");
  const [title, settitle] = useState("");
  const [descripion, setdescripion] = useState("");
  const [audio, setaudio] = useState("");
  const [video, setvideo] = useState("");

  // ******************************************* Photo
  const [Loading, setLoading] = useState();
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader(); fileReader.readAsDataURL(file); fileReader.onload = () => { resolve(fileReader.result); };
      fileReader.onerror = (error) => { reject(error); };
    });
  }
  function uploadSinglePhoto(base64) {
    setLoading(true);
    axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
      .then((res) => { setcoverPicture(res.data); alert("image uploaded Succesfully"); })
      .then(() => setLoading(false))
      .catch(console.log);
  }
  const HandleFileInputChangePhoto = async (event) => {
    const files = event.target.files;
    console.log(files.length);
    if (files.length === 1) {
      const base64 = await convertBase64(files[0]);
      uploadSinglePhoto(base64); return;
    }
    const base64s = [];
    for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
  };
  // **************************************************Vidéo
  function uploadSingleVideo(base64) {
    setLoading(true);
    axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
      .then((res) => { setvideo(res.data); alert("vidéo uploaded Succesfully"); })
      .then(() => setLoading(false))
      .catch(console.log);
  }
  const HandleFileInputChangeVideo = async (event) => {
    const files = event.target.files;
    console.log(files.length);
    if (files.length === 1) {
      const base64 = await convertBase64(files[0]);
      uploadSingleVideo(base64); return;
    }
    const base64s = [];
    for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
  };
  // ***************************************************Audio
  function uploadSingleAudio(base64) {
    setLoading(true);
    axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
      .then((res) => { setaudio(res.data); alert("audio uploaded Succesfully"); })
      .then(() => setLoading(false))
      .catch(console.log);
  }
  const HandleFileInputChangeAudio = async (event) => {
    const files = event.target.files;
    console.log(files.length);
    if (files.length === 1) {
      const base64 = await convertBase64(files[0]);
      uploadSingleAudio(base64); return;
    }
    const base64s = [];
    for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
  };

  return (
    <div className=" modal fade " id="addModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-2" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content rounded-0">
          <div className="modal-header relative">
            <h6 className=" modal-title  text-primary text-uppercase display-7 text-uppercase mb-0 translatable" id="exampleModalLabel" style={{ maxWidth: "600px" }}>
              Ajouter un media enseignement
            </h6>
            <button type="button" className="absolute top-3 right-4 btn btn-close text-2xl " data-bs-dismiss="modal" aria-label="Close">X</button>
          </div>
          <div className="modal-body container flex justify-center">
            <div className="flex justify-center row g-8">
              <div className="col-lg-9">
                <form onSubmit={(e)=>{
                e.preventDefault();
                  CreateSchool(title,coverPicture,descripion,video,audio,navigate);
                }}>
                  <div className="row g-3">
                    <div className="col-12 flex">
                      <label className="form-control border-0 px-4 translatable" style={{ height: "40px" }}>titre</label>
                      <input type="text" value={title} onChange={(e)=>{settitle(e.target.value)}} required className="form-control bg-light border-0 px-4" placeholder="titre de la vidéo" style={{ height: "40px" }} />
                    </div>
                    <div className="col-12 flex">
                      <label className="form-control border-0 px-4 translatable" style={{ height: "40px" }}>Image</label>
                      <input type="file" onChange={HandleFileInputChangePhoto} required className="form-control bg-light border-0 px-4" accept=".JPEG , .JPG ,.PNG" placeholder="image" style={{ height: "40px" }} />
                      {coverPicture && (<img src={`${coverPicture}`} className="h-[50px] h-[50px]" />)}
                    </div>
                    <div className="col-12 flex">
                      <label className="form-control border-0 px-4 translatable" style={{ height: "40px" }}>Video (25 mb max)</label>
                      <input type="file" onChange={HandleFileInputChangeVideo} required className="form-control bg-light border-0 px-4" accept=".MP4" placeholder="vidéo" style={{ height: "40px" }} />
                     {video && ( <p className="text-green-600 translatable">video télécharger</p>)}
                    </div>
                    <div className="col-12 flex">
                      <label className="form-control border-0 px-4 translatable" style={{ height: "40px" }}>Audio</label>
                      <input type="file" onChange={HandleFileInputChangeAudio} required className="form-control bg-light border-0 px-4"  accept=".MP3" placeholder="audio" style={{ height: "40px" }} />
                     {audio && ( <p className="text-green-600 translatable">audio télécharger</p>)}
                    </div>
                    <div className="col-12">
                      <label className="form-control border-0 px-4 translatable" style={{ height: "40px" }}>Description</label>
                      <textarea value={descripion} onChange={(e)=>{setdescripion(e.target.value)}} required className="form-control bg-light border-0 px-4 translatable" placeholder="description evenement" style={{ height: "155px" }} />
                    </div>
                    <div className="col-12">
                      <button className="btn btn-outline-primary w-100 py-3 translatable" type="submit">Ajouter</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ModalAddSchoolBible;
